import axios from "axios";
import { APIURL } from "../config";

const SetNewPasswordApi = async (user) => {
  const url = APIURL + "/account/resetforgotpassword";
  return await axios.post(url, user);
};

export default SetNewPasswordApi;
